/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Pressable, Image } from '@components/atoms'
import { grey } from '@mui/material/colors'
import logoPng from '@public/images/logo/logo_black.png'
import { CookieConsent } from '@utils'

import { useNavigate, redirect } from 'react-router-dom'

export const Footer = () => {
	// hook
	const navigate = useNavigate()

	return (
		<View css={style}>
			<View className="footerView">
				<View className="categGroupView">
					<View className="categView">
						<Pressable className="categButton title" onClick={() => navigate('/shop')}>
							<Text className="categTitle" category="h5">
								SHOP
							</Text>
						</Pressable>
						<Pressable className="categButton" onClick={() => navigate('/shop/kedem6')}>
							<Text className="categTitle">KEDEM 6</Text>
						</Pressable>
						<Pressable className="categButton" onClick={() => navigate('/shop/kedem4')}>
							<Text className="categTitle">KEDEM 4</Text>
						</Pressable>
					</View>

					<View className="categView">
						<Pressable className="categButton title" onClick={() => navigate('/support')}>
							<Text className="categTitle" category="h5">
								SUPPORT
							</Text>
						</Pressable>
						<Pressable className="categButton" onClick={() => navigate('/manuals')}>
							<Text className="categTitle">Manuals</Text>
						</Pressable>
						<Pressable
							className="categButton"
							onClick={() => navigate('/privacy-policy')}
						>
							<Text className="categTitle">Privacy Policy</Text>
						</Pressable>
						<Pressable className="categButton" onClick={() => navigate('/store-policy')}>
							<Text className="categTitle">Store Policy</Text>
						</Pressable>
						<Pressable className="categButton" onClick={() => CookieConsent.reset()}>
							<Text className="categTitle">Cookie Settings</Text>
						</Pressable>
					</View>

					<View className="categView">
						<Pressable className="categButton title">
							<Text className="categTitle" category="h5">
								SOCIAL
							</Text>
						</Pressable>
						<Pressable
							className="categButton"
							onClick={() => window.open('https://www.youtube.com/@judahs-io', '_blank')}
						>
							<Text className="categTitle">YouTube</Text>
						</Pressable>
						<Pressable
							className="categButton"
							onClick={() =>
								window.open('https://www.instagram.com/judahs_social', '_blank')
							}
						>
							<Text className="categTitle">Instagram</Text>
						</Pressable>
					</View>

					<View className="categView" onClick={() => navigate('/contact')}>
						<Pressable className="categButton title">
							<Text className="categTitle" category="h5">
								CONTACT
							</Text>
						</Pressable>
					</View>
				</View>

				<View className="footerLogoOuterView">
					<View className="footerLogoView">
						<Image
							src={logoPng}
							className="logoTitleWhite"
							style={{
								width: '5rem',
								height: '5rem',
								fontSize: 40,
								marginRight: 0,
								opacity: 0.8,
							}}
						/>
					</View>
					<Text className="rightText">{`© ${new Date().getFullYear()} Judahs io`}</Text>
				</View>
			</View>

			<View className="buisniessInfoView">
				<Text category="p2">CEO: Boram Kim</Text>
				<Text category="p2">Business Number: 469-06-02816 (Republic of Korea)</Text>
				<Text category="p2">Tel: +82 51 791 1206</Text>
				<Text category="p2">
					Address: Unit 304, 1225, Gonghang-ro, Gangseo-gu, Busan, 46700, Rep. of KOREA
				</Text>
				<Text category="p2">Email: cs@judahs.io</Text>
			</View>
		</View>
	)
}

const style = css({
	'.footerView': {
		position: 'relative',
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		height: '12rem',
		padding: '1rem 2rem',

		'.categGroupView': {
			display: 'flex',
			'.categView': {
				width: '14rem',
				'.categButton': {
					width: '10rem',
					height: '2rem',

					'.categTitle': {
						margin: 0,
						textAlign: 'left',
					},

					'&.title': {
						marginBottom: '1rem',
					},
				},
			},
		},

		'.footerLogoOuterView': {
			position: 'relative',
			width: '10rem',
			height: '10rem',

			'.footerLogoView': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '10rem',
				height: '10rem',
				marginTop: '-1rem',
			},
			'.rightText': {
				position: 'absolute',
				bottom: '1rem',
				color: grey[700],
			},
		},
	},

	'.buisniessInfoView': {
		padding: '1rem 2rem',
		textAlign: 'left',
		background: grey[900],
		color: 'white',
	},

	'@media (max-width: 900px)': {
		display: 'block',
		height: 'fit-content',
		padding: 0,

		'.footerView': {
			display: 'block',
			height: 'fit-content',

			'.categGroupView': {
				padding: '1rem 2rem',
			},

			'.footerLogoOuterView': {
				// width: '100%',
				height: '12rem',
				paddingBottom: '2rem',

				'.footerLogoView': {
					// width: '100%',
				},
				'.rightText': {
					width: '100%',
					textAlign: 'center',
				},
			},
		},
	},

	'@media (max-width: 720px)': {
		'.footerView': {
			'.categGroupView': {
				display: 'block',
				width: '100%',
				padding: '1rem 0',

				'.categView': {
					marginBottom: '2rem',
				},
			},
		},
	},

	'@media (max-width: 480px)': {
		'.categGroupView': {
			display: 'block',

			'.categView': {
				marginBottom: '5rem',
			},
		},
	},
})
